import { createPortal } from "react-dom";

export const Portal = ({ children, node = document.body }) => {
  return createPortal(children, node);
};
